var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/clock_blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/clock_blue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    stroke: "#356E92",
    strokeWidth: 2,
    points: "6 7 10 10 14 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,1 C14.971,1 19,5.029 19,10 C19,14.971 14.971,19 10,19 C5.029,19 1,14.971 1,10 C1,5.029 5.029,1 10,1 Z M10,2 C5.58857143,2 2,5.58971429 2,10 C2,14.4102857 5.58857143,18 10,18 C14.4114286,18 18,14.4102857 18,10 C18,5.58971429 14.4114286,2 10,2 Z",
    id: "Combined-Shape",
    fill: "#356E92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#356E92",
    points: "15 11 17 11 17 9 15 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#356E92",
    points: "9 17 11 17 11 15 9 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#356E92",
    points: "3 11 5 11 5 9 3 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#356E92",
    points: "9 5 11 5 11 3 9 3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlue);
export default __webpack_public_path__ + "static/media/clock_blue.cf4d7b8a1d02cdc35cec7f2810fa7136.svg";
export { ForwardRef as ReactComponent };